/**
 * @desc loadClientByClientId
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(body: defs.ucenter.Client, options?: any) {
  return updateResponse(
    http(URL + `/load/client`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
